/**
 * Z-index constants for all overlays (mobile and desktop).
 *
 * Values preserve the ordering that already existed informally in the codebase.
 * Every overlay must use these constants — never hardcode z-index values.
 *
 * Rule: overlay uses Z.X, its backdrop uses Z.X - 1.
 */
export const Z = {
  BOTTOM_TABS:             50,
  NOTIFICATIONS_SHEET:     50,  // backdrop at 49, sheet at 50
  PWA_BANNER:              55,
  ADD_TRANSACTION_FAB:     45,  // desktop only — above page content, below in-app overlays/modals
  CATEGORY_PICKER:         61,  // backdrop at 60, sheet at 61
  INCOME_SHEET:            62,
  TRANSACTION_DETAIL:      63,
  BUDGET_MODAL:            64,
  CATEGORY_MANAGER_MODAL:  65,
  GLOBAL_CATEGORIZE_MODAL: 66,
  BANK_CONNECTION_MODAL:   67,
  MORE_SHEET:              68,  // email / accounts / members sheets on MoreScreen
  ADD_TRANSACTION_SHEET:   69,  // mobile full-screen composer
  ADD_TRANSACTION_MODAL:   69,  // desktop only — below toast, above all other modals
  BILLING_PAYMENT_MODAL:   69,  // billing payment sheet — same tier as add-transaction
  ERROR_TOAST:             70,  // always on top of all overlays
};
